
import { Label } from "@/components/ui/label";
import type { FormData } from "./types";
import type { Database } from "@/integrations/supabase/types";

type UserRole = Database['public']['Enums']['user_role'];

interface Props {
  setFormData: (data: FormData) => void;
  formData: FormData;
}

const EditUserRoleSelect = ({ setFormData, formData }: Props) => (
  <div className="grid gap-2">
    <Label htmlFor="role">Role</Label>
    <select
      id="role"
      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors"
      value={formData.role}
      onChange={(e) => setFormData({...formData, role: e.target.value as UserRole})}
    >
      <option value="public">Public</option>
      <option value="pollster">Pollster</option>
      <option value="media">Media</option>
      <option value="admin">Admin</option>
      <option value="super_admin">Super Admin</option>
    </select>
  </div>
);

export default EditUserRoleSelect;
